<template>
    <div class="login container">
        <div class="login-form-wrapper">
            <form @submit.prevent="login" class="login-form" autocomplete="on">
                <img src="../assets/blue-cow.svg" alt="" class="login-logo"/>
                <h1 class="login-title">Lane Closures</h1>
                <b-row>
                    <b-col>
                <div class="form-group">
                    <label for="username">Username</label>
                    <input placeholder="Username" type="text" v-model="username" name="username" class="form-control" :class="{ 'is-invalid': submitted && !username }" autocomplete="username" />
                    <div v-show="submitted && !username" class="invalid-feedback">Username is required</div>
                </div>
							<b-form-group label="Password"
							>
							<b-input-group>
								<b-form-input
								v-model="password"
								name="password"
								id="password"
								:type="passwordFieldType"
								:class="{ 'is-invalid': submitted && !password }" autocomplete="current-password"
								/>
								<b-input-group-append>
									<b-button variant="secondary" @click="switchPasswordVisibility()">show/hide</b-button>
								</b-input-group-append>
							</b-input-group>
                    <div v-show="submitted && !password" class="invalid-feedback">Password is required</div>

						</b-form-group>


                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="8" sm="8"  md="8" class="pr-0">
                <div class="form-group">
                    <b-form-checkbox
                        v-model="rememberMe"
                        name="remember-me"
                    >
                        <span>Remember Me</span>
                    </b-form-checkbox>
                </div>
                    </b-col>
                    <b-col cols="4"  sm="4" md="4" class="text-right pl-0">
                    <button class="btn btn-primary log-btn" :disabled="loading" type="submit">Login</button>
                    </b-col>
                </b-row>
                <div class="form-group">
                    <ul>
                        <li class="align-left">
                            <b-link to="forgot-password">Forgot password?</b-link><br />
                            Don't have an account? <b-link to="register">Register</b-link><br/>
						<a @click="showDisclaimer = true" class="text-link">Read Disclaimer</a><br/>
						<a href="https://laneclosures.winnipeg.ca/help/index.html" target="_blank"><span>Need Help?</span></a>
                        </li>
                        <li>
                        </li>
                    </ul>
                    <img v-show="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    <p v-if="error" class="alert alert-danger" v-text="error"></p>
                </div>
            </form>
        </div>

        <b-modal centered v-model="showDisclaimer" type="info" title="Disclaimer" @confirm="showDisclaimer = false">
     <p>Disclaimer and Indemnity: The information on this web site is provided as a public service and should be used for general information purposes only. Although the information provided is believed to be reliable when posted, <a href="http://www.winnipeg.ca/LaneCLosures" target="_blank">http://www.winnipeg.ca/LaneCLosures</a> cannot guarantee that it is accurate or complete or that it will be current at all times. This site should not be the sole source of information relied upon when determining whether to travel in a particular area. The reporting of adverse conditions does not guarantee that the area has or will be serviced by officials responsible for the area. For information whether a particular section of road will be serviced, you should contact the local officials for the specific area. The information on this web site is subject to change without notice. WWW.Winnipeg.ca AND ITS AFFILIATES ARE NOT RESPONSIBLE IN ANY MANNER FOR DIRECT, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES HOWSOEVER CAUSED RESULTING FROM THE USE, MISUSE OR MISINTERPRETATION OF ANY CONTENT, PRODUCTS OR SERVICES PROVIDED BY THIS WEB SITE.</p>
     <p>By using this site, you agree to indemnify, defend and hold harmless City of Winnipeg and its officials, officers, employees and authorized representatives from and against any liability, loss injury (including injuries resulting in death), demand, action, cost, expense, or claim of any kind, including but not limited to lawyer's fees, relating in any way to your use of the contents, or services provided by this web site.</p>
            <template slot="footer">
                <b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')"/>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Numeral from 'numeral';
import Vue from 'vue';
export default {
    docTitle: "Login - Lane Closures",

    data () {
        return {
            username: '',
            password: '',
            submitted: false,
            loading: false,
            returnUrl: '',
            showDisclaimer:false,
            isButtonDisabled:false,
			passwordFieldType:"password",
			passwordStrength:0,
            error: '',
            rememberMe: false,
        }
    },
    computed: {
        isLoggedIn : function () {
            return this.$store.getters.isLoggedIn
        }
        },
    methods: {
        login () {
            // clear the token...
            localStorage.removeItem('token');
            let that = this;
            let username = this.username,
                password = this.password,
                rememberMe = this.rememberMe
            this.$store.dispatch('login', { username, password, rememberMe })
                .then(function(){
                    if (that.$route.query.redirect) {
                        // that.$router.push(that.$route.query.from);
						that.$router.replace(that.$route.query.redirect);
                        } else {
						// that.$router.push('/');
						that.$router.replace('/');
                    }
                 }
                 )
                .catch(error => {
                	if (error) {
						// console.log(error);
                		if (error.response) {
                    if (error.response.data) {
                        if (error.response.data.error == 'userNotApproved') {
                            that.error = 'Your account is not yet approved. Please contact Lane Closures.'
                        } else if (error.response.data.error == 'userNotActive') {
                            that.error = 'Your account is inactive. Please contact Lane Closures.'
                        } else {
									that.error = 'Username or password is incorrect.  Please make sure that your username and password is entered accurately.  You may have forgotten the "@" symbol in your username.'
                        }
                    }
                    else {
								that.error = 'Username or password is incorrect.  Please make sure that your username and password is entered accurately.  You may have forgotten the "@" symbol in your username.'
                    }
		            }
		           }
                }).finally(() => {
					// console.log("finally");
                });


        },
        SetLocale(locale) {
            this.locale = this.$i18n.locale = localStorage.locale = locale;
            if (this.locale.indexOf("en") == 0) {
                Numeral.locale("en");
            }
            if (this.locale.indexOf("fr") == 0) {
                Numeral.locale("fr");
            }
        },
			switchPasswordVisibility() {
				this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
			},
        ToggleLocale() {
            this.SetLocale(this.locale == 'en-CA' ? 'fr-CA' : 'en-CA');
        },

    },
    mounted() {
        Vue.prototype.$bus.$emit("menu:toggle",0);
        Vue.prototype.$bus.$emit("map:toggle",0);
        if (this.$route.query) {
            if (this.$route.query.u != null) {
                 this.username = this.$route.query.u;
            }
        }
    },
}
</script>
